'use strict';
import $ from 'jquery';
import Player from '@vimeo/player';

export default class VideoAndButtons {
    static init() {
        $('.module-video-and-buttons').each((index, el) => {
            new VideoAndButtons($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.play-vimeo').on('click', this.onClick.bind(this));
    }

    onClick(e) {
        e.preventDefault();
        const img = this.el.find('img');
        this.el.find('iframe').attr("width", img.width()).attr('height', img.height());
        $(e.currentTarget).hide();
        this.el.find('[data-vimeo-id]').show();
        const player = new Player(this.el.find('iframe').get(0));
        player.play();
    }
}